export default {
  en: {
    pageTitle: 'Action Centre',
    addUser: 'Add user',
    errorLoading: 'There was an error loading.',
    info: {
      noRequests: 'No requests found matching the filters.',
    },
    connections: {
      received: '{org} added you as a {role}.',
      messageFrom: 'Message from {org}',
      messageTo: 'Message to {org}',
      rejectionReasonFrom: 'Rejection reason from {org}',
      rejectionReasonTo: 'Rejection reason to {org}',
      addReviewer: 'Is a colleague better suited to review this request?',
      pointOfContact: 'Provided contact',
      contactInfo: '{name} ({email})',
      contactHelpReceived:
        'The contact in your organisation that {org} provided to help verify this request',
      contactHelpSent: 'The contact at {org} you provided to help verify this request',
      sent: '{user} added {org} as a {role}.',
      you: 'You',
      deletedUser: 'Deleted user',
      accept: 'Accept',
      reject: 'Reject',
      cancel: 'Cancel',
      filters: {
        received: 'Received',
        sent: 'Sent',
        all: 'All',
        pending: 'Pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
      },
      modal: {
        title: 'Are you sure you want to cancel the connection request for {0}?',
        cancel: 'Yes, cancel connection request',
        close: 'No',
      },
    },
    mergeRequest: {
      title: 'Another profile for this supplier has been found',
      cta: 'Review duplicate',
      body1:
        'A member on the Risk Ledger network has created a new supplier profile called {orgName} and invited someone on your team to complete an assessment.',
      body2:
        'If you would like to merge this profile into your existing {orgName} profile, review and claim this duplicate. You will then be able to accept the assessment request.',
      pendingRequests: '1 pending connection request | {n} pending connection requests',
      modal: {
        body1: 'We’ve found another profile that may be a duplicate of {orgName}.',
        body2:
          'Merging will remove the other profile and transfer any pending connection requests to your main supplier profile. This will ensure the accuracy of your profile and avoid confusion for your clients connecting to you.',
        claimCta: 'Merge profiles',
        reject: 'Not a duplicate',
        claimSuccessMessage: 'Successfully claimed duplicate profile',
      },
    },
    remediations: {
      received: '{otherOrg} requested you to remediate control {control}.',
      receivedProduct:
        '{otherOrg} requested you to remediate control {control} in relation to {productName}.',
      sent: 'You requested {otherOrg} to remediate control {control}.',
      sentProduct:
        'You requested {otherOrg} to remediate control {control} in relation to {productName}.',
      received_review: 'Awaiting review from {otherOrg} on remediation of control {control}.',
      received_reviewProduct:
        'Awaiting review from {otherOrg} on remediation of control {control} in relation to {productName}.',
      sent_review: '{otherOrg} completed remediation of control {control}.',
      sent_reviewProduct:
        '{otherOrg} completed remediation of control {control} in relation to {productName}.',
      received_complete: '{otherOrg} accepted your remediation of control {control}.',
      received_completeProduct:
        '{otherOrg} accepted your remediation of control {control} in relation to {productName}.',
      sent_complete: '{otherOrg} completed remediation of control {control}.',
      sent_completeProduct:
        '{otherOrg} completed remediation of control {control} in relation to {productName}.',
      review: 'Review',
      view: 'View',
      deadline: 'Deadline:',
      expires: 'Deadline passes {time}',
      expired: 'Deadline passed {time}',
      filters: {
        received: 'Received',
        sent: 'Sent',
        awaiting_review: 'Awaiting review',
        awaiting_response: 'Awaiting remediation',
        completed: 'Completed',
      },
    },
    tabs: {
      connectionRequests: 'Connection requests',
      remediationRequests: 'Remediation requests',
    },
    csvExport: {
      export: 'Export',
      error: 'Failed to generate CSV. Please try again.',
      connectionRequests: {
        filename: 'RiskLedger-ConnectionRequests',
        supplierName: 'Supplier name',
        clientName: 'Client name',
        sender: 'Sender',
        sentDate: 'Sent date',
        status: 'Status',
        pending: 'Pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
        message: 'Message',
        contactName: 'Point of contact name',
        contactEmail: 'Point of contact email',
        acceptedDate: 'Accepted date',
        rejectedDate: 'Rejected date',
        dateFormat: 'yyyy/MM/dd',
      },
    },
  },
};
